import i18n from 'i18next';
import locales from 'resources/Locales';

import {I18NEXT_DEFAULT_LANGUAGE} from './initializei18n';
import {getResources} from './resources';

export function addUserLocale(locale) {
  let formattedLocale =
    (typeof locale === 'string' && locale) || I18NEXT_DEFAULT_LANGUAGE;

  if (formattedLocale === 'en-US') {
    formattedLocale = locales.en;
  }

  const resources = getResources(formattedLocale);

  Object.keys(resources).map((namespace) => {
    i18n.addResourceBundle(formattedLocale, namespace, resources[namespace]);
  });

  i18n.changeLanguage(formattedLocale);
}

export function exists(key) {
  if (!i18n.isInitialized) {
    throw new Error('i18n has not been initialized');
  }

  return i18n.exists(key);
}

export function t(key, options = {}) {
  if (!i18n.isInitialized) {
    throw new Error('i18n has not been initialized');
  }

  return i18n.t(key, options);
}

export default {
  addUserLocale,
  exists,
  t,
};
